import { render, staticRenderFns } from "./MediaField.form-builder.vue?vue&type=template&id=64651c74&scoped=true&"
import script from "./MediaField.form-builder.vue?vue&type=script&lang=js&"
export * from "./MediaField.form-builder.vue?vue&type=script&lang=js&"
import style0 from "./MediaField.form-builder.vue?vue&type=style&index=0&id=64651c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64651c74",
  null
  
)

export default component.exports